// extracted by mini-css-extract-plugin
export var form = "_eq-0";